import type { HTMLAttributes } from 'react';

export type BadgeVariant = 'success' | 'error' | 'neutral' | 'accent';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  success: 'border-primary text-primary',
  error: 'border-accent text-accent',
  neutral: 'border-border text-muted-foreground',
  accent: 'border-accent bg-accent text-accent-foreground',
};

/** Small status pill (provider connection status, "recomendado", ...) — the one spot `rounded-pill` is allowed (design system rule: pill only on chips). */
export function Badge({ variant = 'neutral', className = '', ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-pill border px-3 py-1 font-mono text-xs font-medium uppercase tracking-widest ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    />
  );
}
